import { render, staticRenderFns } from "./p35.vue?vue&type=template&id=6fd9be64&scoped=true&"
import script from "./p35.vue?vue&type=script&lang=js&"
export * from "./p35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9be64",
  null
  
)

export default component.exports